module.exports = __webpack_public_path__ + "static/img/res_1.e05992fe.png";